import { type ReactElement } from 'react';

/**
 * The familiar pushpin glyph used by the compiler pane pins (CompilerPaneCards):
 * FILLED when pinned, OUTLINE-only when not. Purely decorative — the pressed
 * state and accessible label live on the enclosing button — so it is aria-hidden.
 */
export function PushpinIcon({ pinned }: { readonly pinned: boolean }): ReactElement {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill={pinned ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.7"
      aria-hidden="true"
    >
      <path d="m16 3 5 5-4 1-4 4v4l-2 2-3-5-5-3 2-2h4l4-4zM8 16l-5 5" />
    </svg>
  );
}
